import React, { useEffect, useState } from 'react';
import { collection, getDocs, updateDoc, arrayUnion, query, where } from 'firebase/firestore';
import { db } from '../../firebase-config';

const RobotSerialNumberPopup = ({ isOpen, onClose, onSend }) => {
    const [show, setShow] = useState(isOpen);
    const [serialNumber, setSerialNumber] = useState('');
    const [practiceId, setPracticeId] = useState('');
    const [users, setUsers] = useState([]); // State to store users
    const [selectedUser, setSelectedUser] = useState(''); // State to store selected user

    useEffect(() => {
        if (isOpen) {
            setShow(true);
            setSerialNumber('');
            setPracticeId('');
            setSelectedUser(''); // Reset selected user when popup opens
        } else {
            setShow(false);
            setTimeout(onClose, 200);
        }
    }, [isOpen, onClose]);

    useEffect(() => {
        const fetchUsers = async () => {
            const usersCollectionRef = collection(db, 'Companies/Zeeno_Dev/Users');
            const usersSnapshot = await getDocs(usersCollectionRef);
            const usersList = usersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setUsers(usersList);
        };

        fetchUsers();
    }, []);

    const handleClose = () => {
        setSerialNumber('');
        setPracticeId('');
        setSelectedUser(''); // Reset selected user when popup closes
        setShow(false);
        setTimeout(onClose, 200);
    };

    const handleSend = async () => {
        if (selectedUser) {
            const usersCollectionRef = collection(db, 'Companies/Zeeno_Dev/Users');
            const q = query(usersCollectionRef, where('id', '==', selectedUser));
            const querySnapshot = await getDocs(q);
    
            querySnapshot.forEach(async (doc) => {
                const userDocRef = doc.ref;
                await updateDoc(userDocRef, {
                    robots: arrayUnion(serialNumber)
                });
            });
        }
        onSend(serialNumber, practiceId, selectedUser); // Pass selectedUser to parent
        setSerialNumber('');
        setPracticeId('');
        setSelectedUser(''); // Reset fields after sending
        setShow(false);
        setTimeout(onClose, 200);
    };
    return (
        <div
            className={`fixed inset-0 bg-black bg-opacity-50 overflow-y-auto h-full w-full transition-opacity duration-200 ${show ? 'opacity-100' : 'opacity-0'} z-20`}
            onClick={handleClose}
            style={{ display: show || isOpen ? 'block' : 'none' }}
        >
            <div
                className="relative top-20 mx-auto p-4 border w-96 shadow-lg rounded-md bg-white"
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-end">
                    <button onClick={handleClose} className="text-black bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg p-0.5 text-sm ml-auto inline-flex items-center">
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div className="flex flex-col items-center w-fit">
                    <div className='flex flex-row mt-3 gap-4'>
                        <div className='flex flex-col gap-1'>
                            <span className='font-heebo font-light'>Robot Serial Number</span>
                            <input value={serialNumber} onChange={(e) => setSerialNumber(e.target.value)} className='font-heebo font-light w-full bg-[#e1e6fd] p-1 px-2 rounded-md items-center outline-none' placeholder='Enter serial number' />
                        </div>
                        <div className='flex flex-col gap-1'>
                            <span className='font-heebo font-light'>Practice ID (optional)</span>
                            <input value={practiceId} onChange={(e) => setPracticeId(e.target.value)} className='font-heebo font-light w-full bg-[#e1e6fd] p-1 px-2 rounded-md items-center outline-none' placeholder='Enter practice ID (optional)' />
                        </div>
                    </div>
                    <div className='flex flex-col mt-3 gap-1 w-full'>
                        <span className='font-heebo font-light'>Select User</span>
                        <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} className='font-heebo font-light w-full bg-[#e1e6fd] p-1 px-2 rounded-md items-center outline-none'>
                            <option value="">Select a user</option>
                            {users.map(user => (
                                <option key={user.id} value={user.id}>{user.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className='w-full flex justify-center mt-14'>
                    {serialNumber !== '' ? 
                        <div className='flex w-fit bg-[#152FF5] py-1.5 px-5 rounded-3xl items-center cursor-pointer' onClick={handleSend}>
                            <span className='text-white font-heebo'>Submit</span>
                        </div>
                        :
                        <div className='flex w-fit bg-[#152FF5] py-1.5 px-5 rounded-3xl items-center opacity-50'>
                            <span className='text-white font-heebo'>Submit</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default RobotSerialNumberPopup;